export default "__VITE_ASSET__CfXjl6eT__"